import * as React from "react";
import {
  Button,
  Card,
  Chip,
  Box,
  Container,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  Stack,
  FormLabel,
  CircularProgress,
  NativeSelect,
  FormControl,
  InputLabel,
  Tab,
  Menu,
  Tooltip,
  TableCell,
  IconButton,
  Table,
  TableBody,
  TableRow,
  styled,
  tableCellClasses,
  Alert,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  GridColDef,
  GridFilterInputValueProps,
  GridFilterItem,
  GridFilterOperator,
  GridRenderCellParams,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import Grid from "@mui/material/Grid";
import {
  useSetShowHideMutation,
  useSetEnableDisableMutation,
  useSetEnableDisableByItemMutation,
  useGetSyncedProductsMutation,
  useGetDealerManufacturersQuery,
  addDealerManufacturers,
  useSetDmsSyncStatusMutation,
  useUpdateAggregatePriceMutation,
  useHidePricesInBulkMutation,
  useResetPriceSyncTypeMutation,
  useFetchBulkOperationStatusMutation,
} from "../../../redux/reducer/features/Integration/DmsSetupSlice";
import {
  useRemoveBulkAggregateProductsMutation,
  useRevertShopifyCustomDetailsMutation,
} from "../../../redux/reducer/features/Product/productSlice";
import { AppState } from "../../../redux/reducer/rootReducer";
import Switch from "@mui/material/Switch";
import ServerAppGrid from "../../app/ServerAppGrid";
import { AppFilter } from "../../../models/app/AppModels";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import CardContent from "@mui/material/CardContent";
import {
  RequestFor,
  PricingType,
  ProductType,
} from "../../../models/features/Integration/DmsSetup";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useGetDmsManufacturersQuery } from "../../../redux/reducer/features/ShoppingPortal/ShoppingPortalSlice";
import { DmsManufacturer } from "../../../models/features/ShoppingPortal/DmsManufacturer";
import CloseIcon from "@mui/icons-material/Close";
import { AppGridId } from "../../../models/app/AppGridModels";
import {
  GetAppGridColumns,
  usePriceOptions,
  getShopifyVariantData,
  handleGetProductPrice,
  isValueNullOrZero,
  generatePriceIcons,
  formatDate,
  calculateGrossMargin,
  PRICING_WARNING_ICON,
} from "../../../services/utilities/utility";
import WarningIcon from "@mui/icons-material/Warning";
import { customPriceFilterOperators } from "../../app/CustomGridFilterOpereators";
import ShopifyProductDetails from "../../Used Products/ShopifyProductDetails";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ManageHistoryIcon from "@mui/icons-material/ManageHistory";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SnackBarPopup from "../../app/SnackBarPopup";
import SyncDisabledIcon from "@mui/icons-material/SyncDisabled";
import SyncRoundedIcon from "@mui/icons-material/SyncRounded";
import PriceChangeOutlinedIcon from "@mui/icons-material/PriceChangeOutlined";
import PriceRule from "./Grids/PriceRule";
import { setBulkPriceSyncing } from "../../../redux/reducer/features/Auth/authSlice";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: "3px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
interface ProductManageProps {}

const ProductManagement: React.FunctionComponent<ProductManageProps> = () => {
  const WGgridSetting = useSelector((state: AppState) =>
    state?.AppGridReducer?.setting.find(
      (x) => x.gridId === AppGridId.Product_Manager_Wholegoods
    )
  );
  const PartgridSetting = useSelector((state: AppState) =>
    state?.AppGridReducer?.setting.find(
      (x) => x.gridId === AppGridId.Product_Manager_Parts
    )
  );
  const [paging, setPaging] = React.useState<AppFilter>({
    pageIndex: 0,
    pageSize: 10,
    totalRecords: 0,
    items: [],
    quickFilterValues: [],
  });
  const productTypes = useSelector(
    (state: AppState) => state.authReducer.dmsSetup?.productTypes
  );
  const locations = useSelector(
    (state: AppState) => state.authReducer.dmsSetup?.dmsLocations
  );
  const priceOptions = usePriceOptions();
  const [filteredManufacturers, setFilteredManufacturers] = React.useState<
    DmsManufacturer[]
  >([]);
  const [value, setValue] = React.useState("Wholegoods");
  const dispatch = useDispatch();
  const [products, setProducts] = React.useState<any[]>([]);
  const [productsCount, setProductsCount] = React.useState<number>(0);
  const [selectedRows, setSelectedRows] = React.useState<any>([]);
  const [selectedRowData, setSelectedRowData] = React.useState<any>();
  const [open, setOpen] = React.useState(false);
  const [isResetRequest, setIsResetRequest] = React.useState(false);
  const [openPrices, setOpenPrices] = React.useState(false);
  const [openPriceRule, setOpenPriceRule] = React.useState(false);
  const [openHidePrice, setOpenHidePrice] = React.useState(false);
  const [isOperationRunning, setIsOperationRunning] = React.useState(false);
  const [hideValue, setHideValue] = React.useState(false);
  const [priceType, setPriceType] = React.useState<PricingType>();
  const [productType, setProductType] = React.useState(0);
  const [openStockForm, setOpenStockForm] = React.useState(false);
  const [checked, setChecked] = React.useState(true);
  const [openShopifyDetails, setOpenShopifyDetails] = React.useState(false);
  const [openRevertCustom, setOpenRevertCustom] = React.useState(false);
  const [showSaveAlert, setShowSaveAlert] = React.useState(false);
  const [showAlertMessage, setShowAlertMessage] = React.useState("");
  const [productDeleteConfirm, setProductDeleteConfirm] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [openResetPrice, setOpenResetPrice] = React.useState(false);
  const { dmsSetup } = useSelector((state: AppState) => state.authReducer);
  const { data: dmsManufacturersList } = useGetDmsManufacturersQuery({
    dealerId: locations ? locations[0].dealerId.toString() ?? "" : "",
  });

  const manufacturersQuery = useGetDealerManufacturersQuery({});
  var priceTag =
    dmsSetup?.dmsLocations[0].dmsType === 0 ? "web price" : "price level";
  const [syncProduct, syncProductResult] = useGetSyncedProductsMutation();
  const [setSyncStatusMutation, setSyncStatusMutationResult] =
    useSetDmsSyncStatusMutation();
  const [setVisibility, setVisibilityMutationResult] = useSetShowHideMutation();
  const [setStockDecision, setStockDecisionMutationResult] =
    useSetEnableDisableMutation();
  const [setStockDecisionByItem, setStockDecisionByItemMutationResult] =
    useSetEnableDisableByItemMutation();
  const [deleteBulkProductsMutation, deleteBulkProductsMutationResult] =
    useRemoveBulkAggregateProductsMutation();
  const [updatePriceMutation, updatePriceMutationResult] =
    useUpdateAggregatePriceMutation();
  const [hidePriceMutation, hidePriceMutationMutationResult] =
    useHidePricesInBulkMutation();
  const [revertCustomDetailsMutation, revertCustomDetailsMutationResult] =
    useRevertShopifyCustomDetailsMutation();
  const [resetPriceSyncMutation, resetPriceSyncMutationResult] =
    useResetPriceSyncTypeMutation();
  const [
    fetchBulkOperationStatusMutation,
    fetchBulkOperationStatusMutationResult,
  ] = useFetchBulkOperationStatusMutation();
  const [deleteConfirm, setDeleteConfirm] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [anchorAction, setAnchorAction] = React.useState<null | HTMLElement>(
    null
  );
  const openPriceMenu = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  React.useEffect(() => {
    if (
      dmsSetup?.isWholegoodBulkPriceSyncing === false &&
      productType === 0 &&
      !syncProductResult.isLoading
    ) {
      fetchData();
    }
    if (
      dmsSetup?.isPartsBulkPriceSyncing === false &&
      productType === 1 &&
      !syncProductResult.isLoading
    ) {
      fetchData();
    }
  }, [
    dmsSetup?.isWholegoodBulkPriceSyncing,
    dmsSetup?.isPartsBulkPriceSyncing,
  ]);

  React.useEffect(() => {
    console.log("inside useffect");
    if (!dmsSetup) return;

    let intervalId: ReturnType<typeof setInterval> | undefined;

    const isSyncing =
      dmsSetup.isWholegoodBulkPriceSyncing || dmsSetup.isPartsBulkPriceSyncing;

    if (isSyncing) {
      console.log("inside issyncing");

      const fetchStatus = async () => {
        try {
          const res: any = await fetchBulkOperationStatusMutation(null);
          if (res.data?.status === 200 && res.data.entity === false) {
            clearInterval(intervalId);
            intervalId = undefined;
            dispatch(
              setBulkPriceSyncing({
                isSyncing: false,
                productType: ProductType.Wholegoods,
              })
            );
            dispatch(
              setBulkPriceSyncing({
                isSyncing: false,
                productType: ProductType.Parts,
              })
            );
          }
        } catch (error) {
          console.error("Error checking sync status:", error);
        }
      };

      fetchStatus();
      intervalId = setInterval(fetchStatus, 30000);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [
    dmsSetup?.isWholegoodBulkPriceSyncing,
    dmsSetup?.isPartsBulkPriceSyncing,
  ]);

  const handleUpdatePrice = (
    priceType: PricingType,
    price: any,
    compareAtPrice: number
  ) => {
    setPriceType(priceType);
    setIsResetRequest(isResetRequest);
    updatePriceMutation({
      aggregateId: selectedRowData?.id ?? "",
      shopifyVariantId: selectedRowData?.shopifyVariantId ?? 0,
      hasActivePromotion: selectedRowData?.activePromotion ? true : false,
      price: price,
      aggregatePriceType: priceType,
      compareAtPrice: compareAtPrice,
    }).then((res: any) => {
      if (res.data && res.data.status === 200) {
        fetchData();
        setOpenPrices(false);
        setIsResetRequest(false);
      }
    });
  };

  React.useEffect(() => {
    if (
      dmsManufacturersList?.entityList &&
      dmsManufacturersList.entityList?.length > 0
    ) {
      setFilteredManufacturers(dmsManufacturersList.entityList);
    }
  }, [dmsManufacturersList]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
    if (newValue === "Wholegoods") {
      setProductType(0);
    } else {
      setProductType(1);
    }
    setPaging({ ...paging, quickFilterValues: [], items: [] });
  };
  const handleDecisionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  const handleDecisionChangeSingleItem = (product: any, checked: boolean) => {
    setProducts(
      products.map((item) =>
        item.id === product.productAggId
          ? {
              ...item,
              shopifyProduct: {
                ...item.shopifyProduct,
                variants: [
                  {
                    ...item.shopifyProduct.variants[0],
                    inventoryPolicy: checked ? "continue" : "deny",
                  },
                ],
              },
            }
          : item
      )
    );

    handleStockDecisionSubmitByItem(product, checked ? "yes" : "no");
  };
  const handleClose = () => {
    setAnchorAction(null);
    setOpenShopifyDetails(false);
    setOpen(false);
    setOpenPrices(false);
    setOpenPriceRule(false);
    setAnchorEl(null);
    setOpenStockForm(false);
    setDeleteConfirm(false);
    setOpenHidePrice(false);
    setOpenRevertCustom(false);
    setProductDeleteConfirm(false);
    setOpenResetPrice(false);
  };
  const handleClosePriceRule = (refreshData: boolean) => {
    setAnchorEl(null);
    setOpenPriceRule(false);
    if (refreshData) {
      fetchData();
    }
  };
  const handleGetRowColor = (price: PricingType) => {
    let color = "";
    if (selectedRowData?.priceType === PricingType[price]) {
      color = "rgb(237, 247, 237)";
    }
    return color;
  };
  const handleRevertCustomDetails = () => {
    revertCustomDetailsMutation({ aggregateId: selectedRowData?.id }).then(
      (res: any) => {
        if (res.data && res.data.status === 200) {
          fetchData();
          setOpenRevertCustom(false);
        }
      }
    );
  };

  const handleDeleteProduct = () => {
    deleteBulkProductsMutation({
      ProductAggregateIds: [selectedRowData.id],
    }).then((res: any) => {
      if (res.data && res.data.status === 200) {
        fetchData();
        setProductDeleteConfirm(false);
      }
    });
  };
  const handleResetPrice = () => {
    setErrorMessage("");
    resetPriceSyncMutation({
      pricing:
        value === "Wholegoods"
          ? dmsSetup?.priceType ?? PricingType.Price
          : dmsSetup?.partsPriceType ?? PricingType.Price,
      productType: productType,
      productIds: selectedRows,
    }).then((res: any) => {
      if (res?.data && res?.data?.status === 200) {
        handleClose();
        fetchData();
      } else {
        if (res?.data && res?.data?.status === 208) {
          setErrorMessage(
            "A bulk operation for price updates is already running. Please wait for a while to complete it!"
          );
        } else if (res?.data?.status === 400) {
          setErrorMessage(
            "Found error while updating prices. Please contact to the support!"
          );
        } else handleClose();
      }
    });
  };
  function RatingInputValue(props: GridFilterInputValueProps) {
    const { item, applyValue, focusElementRef } = props;

    const ratingRef: React.Ref<any> = React.useRef(null);

    const handleDropdownFilterChange = (event: any) => {
      applyValue({
        ...item,
        value: event.target.value !== "all" ? event.target.value : undefined,
      });
    };
    return (
      <FormControl fullWidth>
        <InputLabel variant="standard" htmlFor="uncontrolled-native">
          Manufacturer
        </InputLabel>
        <NativeSelect
          ref={ratingRef}
          value={item.value ? item.value : "all"}
          defaultValue="all"
          inputProps={{
            name: "age",
            id: "uncontrolled-native",
          }}
          onChange={handleDropdownFilterChange}
        >
          <option value={"all"}>All</option>
          {filteredManufacturers
            .filter((m) =>
              productType === 0
                ? m.isWholegoodManufacturer
                : m.isPartManufacturer
            )
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((n) => (
              <option key={n.code} value={n.code}>
                {n.name}
              </option>
            ))}
        </NativeSelect>
      </FormControl>
    );
  }
  const handleUpdateProductMatchingType = (productId: string, type: string) => {
    setProducts(
      products.map((item) =>
        item.id === productId
          ? {
              ...item,
              matchingType: type,
            }
          : item
      )
    );
  };
  const ratingOnlyOperators: GridFilterOperator[] = [
    {
      label: "Equals",
      value: "equals",
      getApplyFilterFn: (filterItem: GridFilterItem) => {
        if (
          !filterItem.columnField ||
          !filterItem.value ||
          !filterItem.operatorValue
        ) {
          return null;
        }

        return (params): boolean => {
          return params.value == filterItem.value;
        };
      },
      InputComponent: RatingInputValue,
      InputComponentProps: { type: "number" },
    },
  ];
  const getPriceIcon = (product?: any): React.ReactNode => {
    if (
      !product?.aggregatePrices &&
      (product?.price == null || product?.price === 0)
    ) {
      return (
        <Tooltip title="This product does not have any price data.">
          <WarningIcon color="error" fontSize="small" />
        </Tooltip>
      );
    }

    // 1) Price sync must be enabled
    if (!product.enablePriceSync) {
      return (
        <Tooltip title="Price sync is off for this product.">
          <SyncDisabledIcon color="error" />
        </Tooltip>
      );
    }

    // 2) Promotion trumps everything
    if (product.activePromotion) {
      return (
        <Tooltip title="There is an ongoing promotion for this product.">
          <PriceChangeOutlinedIcon color="success" />
        </Tooltip>
      );
    }

    // 5) Map enum value -> enum name string (e.g. PriceLevel1)
    const priceTypeName =
      PricingType[product.priceType as keyof typeof PricingType];

    // 6) Find the priceOptions entry that tells us which aggregatePrices key to use
    const priceOption = priceOptions.find((p) => p.type === priceTypeName);

    const resolvedPrice = product?.aggregatePrices[priceOption?.key ?? "price"];
    if (resolvedPrice == null || resolvedPrice === 0)
      return PRICING_WARNING_ICON;

    return generatePriceIcons(product.priceType, priceTag);
  };
  const columns: GridColDef[] = [
    {
      field: "manufacturer",
      headerName: "Manufacturer",
      width: 200,
      filterOperators: ratingOnlyOperators,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Tooltip title={params.row.manufacturer}>
            <Typography sx={{ fontSize: "0.875rem" }}>
              {params.row.manufacturer}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: "modelNumber",
      headerName: "Model Name",
      width: 210,
      renderCell: (params: GridRenderCellParams) => {
        return params.row.productId ? (
          <>
            <Box
              style={{
                width: "50px",
                height: "50px",
                backgroundColor: "white",
              }}
            >
              <img
                style={{ maxWidth: "100%", maxHeight: "100%" }}
                alt=""
                src={getIconImageUrl(
                  params.row.shopifyProduct &&
                    params.row.shopifyProduct.images.length !== 0
                    ? params.row.shopifyProduct.images[0].src
                    : "",
                )}
              ></img>{" "}
            </Box>
            <Tooltip title={params.row.modelNumber}>
              <Typography
                sx={{ cursor: "pointer", fontSize: "0.875rem" }}
                color="primary"
                pl={3}
              >
                {params.row.modelNumber}
              </Typography>
            </Tooltip>
          </>
        ) : (
          <Tooltip title={params.row.modelNumber}>
            <Typography sx={{ fontSize: "0.875rem" }}>
              {params.row.modelNumber}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: "title",
      headerName: "Title",
      width: 150,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Tooltip title={params.row.title}>
            <Typography sx={{ fontSize: "0.875rem" }}>
              {params.row.title}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: "model",
      headerName: "DMS Model",
      width: 180,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Tooltip title={params.row.model}>
            <Typography sx={{ fontSize: "0.875rem" }}>
              {params.row.model}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: "cost",
      headerName: "Cost ($)",
      headerAlign: "right",
      width: 100,
      align: "right",
      type: "number",
      filterable: false,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.cost.toFixed(2),
    },
    {
      field: "price",
      headerName: "MSRP ($)",
      headerAlign: "right",
      width: 120,
      filterOperators: customPriceFilterOperators,
      type: "number",
      align: "right",
      sortable: true,
      valueGetter: (params: GridValueGetterParams<any>) => {
        return params?.row?.price.toFixed(2) ?? 0.0;
      },
    },
    {
      field: "grossMargin",
      headerName: "Gross Margin (%)",
      renderHeader: () => (
        <Tooltip title="Gross Margin = ((Web Price - Cost) / Web Price ) * 100">
          <span>Gross Margin (%)</span>
        </Tooltip>
      ),
      headerAlign: "right",
      width: 130,
      type: "number",
      align: "right",
      filterable: false,
      valueGetter: (params: GridValueGetterParams<any>) => {
        const cost = Number(params.row.cost) || 0;
        const shopifyPrice = params.row.shopifyProduct
          ? Number(getShopifyVariantData(params.row)?.price) || 0
          : 0;
        return calculateGrossMargin(cost, shopifyPrice);
      },
    },
    {
      field: "storeprice",
      headerName: "Web Price ($)",
      headerAlign: "right",
      width: 130,
      align: dmsSetup?.isWholegoodBulkPriceSyncing ? "center" : "right",
      type: "number",
      filterable: false,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.shopifyProduct
          ? getShopifyVariantData(params.row)?.price?.toFixed(2)
          : "0.00",
      renderCell: (params) => {
        const { shopifyProduct } = params.row;
        const metafields = shopifyProduct?.metafields || [];
        const hidePrice = metafields.find(
          (metafield: any) =>
            metafield.key === "hidePrice" && metafield.value === "true"
        );

        return (
          <>
            {dmsSetup?.isWholegoodBulkPriceSyncing ? (
              <Tooltip title="A bulk price update is in progress. Please wait until it is completed.">
                <SyncRoundedIcon fontSize="small" color="primary" />
              </Tooltip>
            ) : (
              <>
                {hidePrice && (
                  <Tooltip title="The price of this product is hidden on Shopify">
                    <WarningIcon fontSize="small" color="warning" />
                  </Tooltip>
                )}
                <Button
                  onClick={() => {
                    setSelectedRowData(params.row);
                    setOpenPrices(true);
                  }}
                >
                  {params.value}
                </Button>
                {getPriceIcon(params.row)}
              </>
            )}
          </>
        );
      },
    },
    {
      field: "stock",
      headerName: "Stock",
      headerAlign: "right",
      width: 70,
      align: "right",
      type: "number",
      filterable: false,
      valueGetter: (params: GridValueGetterParams<any>) => {
        if (params.row.stock) {
          return params.row?.stock?.reduce(
            (partial: number, value: any) => partial + value.stock,
            0
          );
        }
      },
      renderCell: (params: GridRenderCellParams) => {
        var stock = params.row?.stock?.reduce(
          (partial: number, value: any) => partial + value.stock,
          0
        );
        const hasShopifyLocation =
          locations && locations.some((l) => l.shopifyLocationId > 0);
        return hasShopifyLocation ? (
          <Tooltip
            title={
              <>
                {locations!
                  .filter((l) => l.shopifyLocationId > 0)
                  .map((e, index: number) => {
                    var locationStock = params.row?.stock.find(
                      (n: any) => n.dmsLocationId === e.id
                    );
                    return (
                      <Typography key={index}>
                        {e.name}: {locationStock?.stock ?? 0}
                      </Typography>
                    );
                  })}
              </>
            }
          >
            <Typography
              sx={{
                cursor: "pointer",
                fontSize: "inherit",
                lineHeight: "inherit",
                letterSpacing: "inherit",
              }}
            >
              {stock}
            </Typography>
          </Tooltip>
        ) : null;
      },
    },
    {
      field: "storeStock",
      headerName: "Online Stock",
      headerAlign: "right",
      width: 100,
      align: "right",
      type: "number",
      filterable: false,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.shopifyProduct
          ? getShopifyVariantData(params.row)?.inventoryQuantity
          : "0",
      renderCell: (params) => params.value,
    },
    {
      field: "outOfStock",
      headerName: "OutStock Selling",
      type: "actions",
      width: 130,
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return params.row?.shopifyProduct ? (
          <Switch
            size="small"
            aria-labelledby="demo-controlled-radio-buttons-group"
            checked={
              params.row?.shopifyProduct.variants[0].inventoryPolicy.toLowerCase() ===
              "deny"
                ? false
                : true
            }
            name="status"
            onChange={(e) => {
              handleDecisionChangeSingleItem(
                {
                  shopifyProductId: params.row?.shopifyProductId,
                  productAggId: params.row?.id,
                },
                e.target.checked
              );
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        ) : (
          ""
        );
      },
    },
    {
      field: "disableStockSync",
      headerName: "Stock Sync",
      type: "actions",
      width: 100,
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Switch
            size="small"
            aria-labelledby="demo-controlled-radio-buttons-group"
            checked={params.row?.enableStockSync}
            name="status"
            onChange={(e) => {
              handleAggregateSyncStatus(
                params.row.id,
                RequestFor.Stock,
                e.target.checked
              );
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        );
      },
    },
    {
      field: "disablePriceSync",
      headerName: "Price Sync",
      type: "actions",
      width: 100,
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Switch
            size="small"
            aria-labelledby="demo-controlled-radio-buttons-group"
            checked={params.row?.enablePriceSync}
            name="status"
            onChange={(e) => {
              handleAggregateSyncStatus(
                params.row.id,
                RequestFor.Price,
                e.target.checked
              );
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        );
      },
    },
    {
      field: "enableCatalogSync",
      headerName: "Catalog Sync",
      type: "actions",
      width: 110,
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Switch
            size="small"
            checked={
              params.row?.matchingType === "Custom" ||
              params.row?.matchingType === "DMS"
                ? false
                : params.row?.enableCatalogSync
            }
            disabled={
              params.row?.matchingType === "Custom" ||
              params.row?.matchingType === "DMS"
            }
            name="status"
            onChange={(e) => {
              handleAggregateSyncStatus(
                params.row.id,
                RequestFor.Catalog,
                e.target.checked
              );
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      align: "center",
      headerAlign: "center",
      width: 100,
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return getStatusChip(params.row);
      },
    },
    {
      field: "isExistingProduct",
      headerName: "Sync Type",
      headerAlign: "center",
      width: 100,
      align: "center",
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return params?.row?.isExistingProduct ? (
          <Chip label="Reverse" color="warning" size="small" />
        ) : (
          <Chip label="Regular" color="success" size="small" />
        );
      },
    },
    {
      field: "type",
      headerName: "Matching Type",
      width: 120,
      align: "center",
      headerAlign: "center",
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return params.row.matchingType === "Catalog" ? (
          <Chip label="Catalog" color="success" size="small" />
        ) : params.row.matchingType === "DMS" ? (
          <Chip label="DMS" color="warning" size="small" />
        ) : (
          <Chip label="Custom" color="info" size="small" />
        );
      },
    },
    {
      field: "actions",
      headerName: "View / Edit",
      type: "actions",
      // width: 80,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <>
            <Chip
              label="Action"
              color="info"
              size="small"
              onClick={(event) => {
                setSelectedRowData(params.row);
                setAnchorAction(event.currentTarget);
              }}
            />
            <Menu
              anchorEl={anchorAction}
              open={Boolean(anchorAction)}
              onClose={handleClose}
            >
              <MenuItem
                onClick={() => {
                  window.open(
                    `${dmsSetup?.shopifyUrl}/products/${selectedRowData?.shopifyProductLink}`,
                    "_blank"
                  );
                  setAnchorAction(null);
                }}
              >
                <ListItemIcon>
                  <VisibilityIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>View in site</ListItemText>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setOpenShopifyDetails(true);
                  setAnchorAction(null);
                }}
              >
                <ListItemIcon>
                  <EditIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Edit</ListItemText>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setProductDeleteConfirm(true);
                  setAnchorAction(null);
                }}
              >
                <ListItemIcon>
                  <DeleteForeverIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Delete</ListItemText>
              </MenuItem>
              <MenuItem
                disabled={
                  selectedRowData?.matchingType !== "Custom" ||
                  !selectedRowData.productId
                }
                onClick={() => {
                  setOpenRevertCustom(true);
                  setAnchorAction(null);
                }}
              >
                <ListItemIcon>
                  <ManageHistoryIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Use Catalog</ListItemText>
              </MenuItem>
            </Menu>
          </>
        );
      },
    },
  ];
  const partsColumns: GridColDef[] = [
    {
      field: "manufacturer",
      headerName: "Manufacturer",
      width: 200,
      filterOperators: ratingOnlyOperators,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Tooltip title={params.row.manufacturer}>
            <Typography sx={{ fontSize: "0.875rem" }}>
              {params.row.manufacturer}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: "partNumber",
      headerName: "Part Number",
      width: 200,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.partNumber,
    },
    {
      field: "cost",
      headerName: "Cost ($)",
      headerAlign: "right",
      width: 100,
      align: "right",
      type: "number",
      filterable: false,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.cost.toFixed(2),
    },
    {
      field: "price",
      headerName: "MSRP ($)",
      headerAlign: "right",
      width: 120,
      filterOperators: customPriceFilterOperators,
      type: "number",
      align: "right",
      sortable: true,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.price.toFixed(2),
    },
    {
      field: "grossMargin",
      headerName: "Gross Margin (%)",
      renderHeader: () => (
        <Tooltip title="Gross Margin = ((Web Price - Cost) / Web Price ) * 100">
          <span>Gross Margin (%)</span>
        </Tooltip>
      ),
      headerAlign: "right",
      width: 130,
      type: "number",
      align: "right",
      filterable: false,
      valueGetter: (params: GridValueGetterParams<any>) => {
        const cost = Number(params.row.cost) || 0;
        const shopifyPrice = params.row.shopifyProduct
          ? Number(getShopifyVariantData(params.row)?.price) || 0
          : 0;
        return calculateGrossMargin(cost, shopifyPrice);
      },
    },
    {
      field: "storeprice",
      headerName: "Web Price ($)",
      headerAlign: "right",
      width: 130,
      align: dmsSetup?.isPartsBulkPriceSyncing ? "center" : "right",
      type: "number",
      filterable: false,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.shopifyProduct
          ? getShopifyVariantData(params.row)?.price?.toFixed(2)
          : "0.00",
      renderCell: (params) => {
        const { shopifyProduct } = params.row;
        const metafields = shopifyProduct?.metafields || [];
        const hidePrice = metafields.find(
          (metafield: any) =>
            metafield.key === "hidePrice" && metafield.value === "true"
        );
        return (
          <>
            {dmsSetup?.isPartsBulkPriceSyncing ? (
              <Tooltip title="A bulk price update is in progress. Please wait until it is completed.">
                <SyncRoundedIcon fontSize="small" sx={{ color: "black" }} />
              </Tooltip>
            ) : (
              <>
                {hidePrice && (
                  <Tooltip title="The price of this product is hidden on Shopify">
                    <WarningIcon fontSize="small" color="warning" />
                  </Tooltip>
                )}
                <Button
                  onClick={() => {
                    setSelectedRowData(params.row);
                    setOpenPrices(true);
                  }}
                >
                  {params.value}
                </Button>
                {getPriceIcon(params.row)}
              </>
            )}
          </>
        );
      },
    },
    {
      field: "stock",
      headerName: "Stock",
      headerAlign: "right",
      width: 70,
      align: "right",
      type: "number",
      filterable: false,
      valueGetter: (params: GridValueGetterParams<any>) => {
        if (params.row.stock) {
          return params.row?.stock?.reduce(
            (partial: number, value: any) => partial + value.stock,
            0
          );
        }
      },
      renderCell: (params: GridRenderCellParams) => {
        var stock = params.row?.stock?.reduce(
          (partial: number, value: any) => partial + value.stock,
          0
        );
        const hasShopifyLocation =
          locations && locations.some((l) => l.shopifyLocationId > 0);
        return hasShopifyLocation ? (
          <Tooltip
            title={
              <>
                {locations!
                  .filter((l) => l.shopifyLocationId > 0)
                  .map((e, index: number) => {
                    var locationStock = params.row?.stock.find(
                      (n: any) => n.dmsLocationId === e.id
                    );
                    return (
                      <Typography key={index}>
                        {e.name}: {locationStock?.stock ?? 0}
                      </Typography>
                    );
                  })}
              </>
            }
          >
            <Typography
              sx={{
                cursor: "pointer",
                fontSize: "inherit",
                lineHeight: "inherit",
                letterSpacing: "inherit",
              }}
            >
              {stock}
            </Typography>
          </Tooltip>
        ) : null;
      },
    },

    {
      field: "outOfStock",
      headerName: "OutStock Selling",
      type: "actions",
      width: 130,
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return params.row?.shopifyProduct ? (
          <Switch
            aria-labelledby="demo-controlled-radio-buttons-group"
            checked={
              params.row?.shopifyProduct.variants[0].inventoryPolicy.toLowerCase() ===
              "deny"
                ? false
                : true
            }
            name="status"
            size="small"
            onChange={(e) => {
              handleDecisionChangeSingleItem(
                {
                  shopifyProductId: params.row?.shopifyProductId,
                  productAggId: params.row?.id,
                },
                e.target.checked
              );
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        ) : (
          ""
        );
      },
    },
    {
      field: "disableStockSync",
      headerName: "Stock Sync",
      type: "actions",
      width: 100,
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Switch
            aria-labelledby="demo-controlled-radio-buttons-group"
            checked={params.row?.enableStockSync}
            name="status"
            size="small"
            onChange={(e) => {
              handleAggregateSyncStatus(
                params.row.id,
                RequestFor.Stock,
                e.target.checked
              );
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        );
      },
    },
    {
      field: "disablePriceSync",
      headerName: "Price Sync",
      type: "actions",
      width: 100,
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Switch
            aria-labelledby="demo-controlled-radio-buttons-group"
            checked={params.row?.enablePriceSync}
            name="status"
            size="small"
            onChange={(e) => {
              handleAggregateSyncStatus(
                params.row.id,
                RequestFor.Price,
                e.target.checked
              );
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      align: "center",
      headerAlign: "center",
      width: 100,
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return getStatusChip(params.row);
      },
    },
    {
      field: "isExistingProduct",
      headerName: "Sync Type",
      headerAlign: "center",
      width: 100,
      align: "center",
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return params?.row?.isExistingProduct ? (
          <Chip label="Reverse" color="warning" size="small" />
        ) : (
          <Chip label="Regular" color="success" size="small" />
        );
      },
    },
    {
      field: "type",
      headerName: "Matching Type",
      width: 120,
      align: "center",
      headerAlign: "center",
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return params.row.matchingType === "DMS" ? (
          <Chip label="DMS" color="warning" size="small" />
        ) : (
          <Chip label="Custom" color="info" size="small" />
        );
      },
    },
    {
      field: "actions",
      headerName: "View / Edit",
      type: "actions",
      renderCell: (params: GridRenderCellParams) => {
        return (
          <>
            <Chip
              label="Action"
              color="info"
              size="small"
              onClick={(event) => {
                setSelectedRowData(params.row);
                setAnchorAction(event.currentTarget);
              }}
            />
            <Menu
              anchorEl={anchorAction}
              open={Boolean(anchorAction)}
              onClose={handleClose}
            >
              <MenuItem
                onClick={() => {
                  window.open(
                    `${dmsSetup?.shopifyUrl}/products/${selectedRowData?.shopifyProductLink}`,
                    "_blank"
                  );
                  setAnchorAction(null);
                }}
              >
                <ListItemIcon>
                  <VisibilityIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>View in site</ListItemText>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setOpenShopifyDetails(true);
                  setAnchorAction(null);
                }}
              >
                <ListItemIcon>
                  <EditIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Edit</ListItemText>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setProductDeleteConfirm(true);
                  setAnchorAction(null);
                }}
              >
                <ListItemIcon>
                  <DeleteForeverIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Delete</ListItemText>
              </MenuItem>
            </Menu>
          </>
        );
      },
    },
  ];

  const getStatusChip = (product: any) => {
    if (product?.shopifyProduct && product.shopifyProduct.status === "ACTIVE")
      return (
        <Chip
          sx={{ cursor: "pointer" }}
          label="Active"
          onDelete={() =>
            handleShowHideSubmit(product.id, product.shopifyProductId, "hide")
          }
          color="success"
          disabled={setVisibilityMutationResult.isLoading}
          size="small"
        />
      );
    else
      return (
        <Chip
          onDelete={() =>
            handleShowHideSubmit(product.id, product.shopifyProductId, "show")
          }
          disabled={setVisibilityMutationResult.isLoading}
          label="Draft"
          color="error"
          size="small"
        />
      );
  };

  React.useEffect(() => {
    fetchData();
  }, [paging, productType]);

  const fetchData = () => {
    syncProduct({
      setupId: dmsSetup?.id ?? "",
      paging: paging,
      productType: productType,
    });
  };

  React.useEffect(() => {
    if (syncProductResult.data) {
      setProducts(syncProductResult.data.entityList);
      setProductsCount(syncProductResult.data.totalRecords);
    }
  }, [syncProductResult]);

  const handleShowHideSubmit = (
    aggregateId: string,
    shopifyProductId: number,
    action: string
  ) => {
    let selectedItems = [
      { shopifyProductId: shopifyProductId, productAggId: aggregateId },
    ];
    setVisibility({
      products: selectedItems,
      decision: action,
    }).then((res: any) => {
      if (res && res.data.status === 0) {
        setProducts(
          products.map((x) =>
            x.id === aggregateId
              ? {
                  ...x,
                  shopifyProduct: {
                    ...x.shopifyProduct,
                    status: action === "show" ? "ACTIVE" : "DRAFT",
                  },
                }
              : x
          )
        );
      }
    });
  };

  const handleDeleteSubmit = async () => {
    let selectedItems = getSelectedRowData();
    const ids = selectedItems.map((n: any) => n.productAggId);
    deleteBulkProductsMutation({
      ProductAggregateIds: ids,
    }).then((res: any) => {
      if (res && res.data) {
        setDeleteConfirm(false);
        setSelectedRows([]);
        fetchData();
      }
    });
  };

  const handleHidePrice = () => {
    let selectedItems = getSelectedRowData();
    if (selectedItems && selectedItems.length > 0) {
      let shopifyProductIds = selectedItems.map(
        (item: any) => item.shopifyProductId
      );
      hidePriceMutation({
        shopifyProductIds: shopifyProductIds,
        hidePrice: hideValue,
      }).then((res: any) => {
        if (res && res.data) {
          if (res.data.status === 200) {
            setAnchorEl(null);
            setOpenHidePrice(false);
            setSelectedRows([]);
            fetchData();
          } else if (res.data.status === 208) {
            setIsOperationRunning(true);
          }
        }
      });
    }
  };
  const hasHiddenPriceProduct = (): boolean => {
    const filteredProducts = products.filter((product: any) =>
      selectedRows.includes(product.id)
    );
    return filteredProducts.some((product: any) => {
      const { shopifyProduct } = product;
      if (shopifyProduct) {
        const metafields = shopifyProduct.metafields || [];
        return metafields.some(
          (metafield: any) =>
            metafield.key === "hidePrice" && metafield.value === "true"
        );
      }
      return false;
    });
  };

  const hasNotHiddenPriceProduct = (): boolean => {
    const filteredProducts = products.filter((product: any) =>
      selectedRows.includes(product.id)
    );
    return filteredProducts.some((product: any) => {
      const { shopifyProduct } = product;
      if (shopifyProduct) {
        const metafields = shopifyProduct.metafields || [];
        return !metafields.some(
          (metafield: any) =>
            metafield.key === "hidePrice" && metafield.value === "true"
        );
      }
      return false;
    });
  };

  const handleStockDecisionSubmit = () => {
    setStockDecision({
      products: getSelectedRowData(),
      decision: checked ? "yes" : "no",
    }).then((res: any) => {
      setOpenStockForm(false);
      fetchData();
    });
  };

  const handleStockDecisionSubmitByItem = (product: any, decision: string) => {
    setStockDecisionByItem({
      products: [product],
      decision: decision,
    });
  };
  const getSelectedRowData = () => {
    return selectedRows.map((rowId: any) => {
      let item = products.find((n) => n.id === rowId);

      if (item) {
        return {
          shopifyProductId: item.shopifyProductId,
          productAggId: rowId,
        };
      }
    });
  };

  React.useEffect(() => {
    if (manufacturersQuery.data) {
      const filteredDmsManufacturers =
        manufacturersQuery.data.entityList?.map((mfr) =>
          !mfr.name?.trim()
            ? {
                ...mfr,
                name:
                  dmsManufacturersList?.entityList?.find(
                    (dmsMfr) =>
                      dmsMfr.code === mfr.code &&
                      dmsMfr.manufacturerId === mfr.manufacturerId
                  )?.name || mfr.code,
              }
            : mfr
        ) || [];
      setFilteredManufacturers(filteredDmsManufacturers);
    }
  }, [manufacturersQuery.data, dmsManufacturersList]);

  const getIconImageUrl = (imgUrl: string) => {
    var splitImageUrl = imgUrl.slice(0, imgUrl.lastIndexOf("."));
    var extention = imgUrl.slice(imgUrl.lastIndexOf("."));
    return splitImageUrl + "_350x350" + extention;
  };

  const handleAggregateSyncStatus = (
    id: string,
    enableOption: RequestFor,
    isEnable: boolean
  ) => {
    setSyncStatusMutation({
      request: {
        aggregateId: id,
        requestFor: enableOption,
        isEnable: isEnable,
      },
    }).then((res) => {
      if (enableOption == RequestFor.Price && isEnable) fetchData();
    });
    if (enableOption == RequestFor.Price) {
      setProducts(
        products.map((item) =>
          item.id === id ? { ...item, enablePriceSync: isEnable } : item
        )
      );
    } else if (enableOption == RequestFor.Stock) {
      setProducts(
        products.map((item) =>
          item.id === id ? { ...item, enableStockSync: isEnable } : item
        )
      );
    } else if (enableOption == RequestFor.Catalog) {
      setProducts(
        products.map((item) =>
          item.id === id ? { ...item, enableCatalogSync: isEnable } : item
        )
      );
    }
  };
  return (
    <>
      <Container maxWidth={false}>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={8}>
            <Grid item xs={4} key={1}>
              <Typography variant="h6" sx={{ fontWeight: "bold" }} gutterBottom>
                Product Manager
              </Typography>
            </Grid>
            <Grid item xs={8} key={2}>
              <Grid container sx={{ justifyContent: "right" }} spacing={2}>
                <Grid item key={1}>
                  <Typography
                    sx={{ fontWeight: "bold", pt: "5px" }}
                    variant="subtitle2"
                    gutterBottom
                  >
                    Apply Rule to Selected Items:
                  </Typography>
                </Grid>
                <Grid item key={2}>
                  <Button
                    id="basic-button"
                    aria-controls={open ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    disabled={selectedRows.length === 0 ? true : false}
                    color="warning"
                    variant="contained"
                    size="small"
                    aria-expanded={open ? "true" : undefined}
                    onClick={handleClick}
                    endIcon={<KeyboardArrowDownIcon />}
                  >
                    Price
                  </Button>
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={openPriceMenu}
                    onClose={handleClose}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >
                    <MenuItem
                      onClick={() => {
                        setOpenPriceRule(true);
                      }}
                    >
                      Price Rule
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        setOpenResetPrice(true);
                      }}
                    >
                      Reset Price
                    </MenuItem>
                    <MenuItem
                      disabled={
                        Boolean(anchorEl) && !hasNotHiddenPriceProduct()
                      }
                      onClick={() => {
                        setIsOperationRunning(false);
                        setHideValue(true);
                        setOpenHidePrice(true);
                      }}
                    >
                      Hide Price
                    </MenuItem>
                    <MenuItem
                      disabled={Boolean(anchorEl) && !hasHiddenPriceProduct()}
                      onClick={() => {
                        setIsOperationRunning(false);
                        setHideValue(false);
                        setOpenHidePrice(true);
                      }}
                    >
                      Show Price
                    </MenuItem>
                  </Menu>
                  <Button
                    disabled={selectedRows.length === 0 ? true : false}
                    color="warning"
                    sx={{ ml: 2 }}
                    variant="contained"
                    size="small"
                    onClick={(e) => {
                      setOpenStockForm(true);
                    }}
                  >
                    Out of Stock Selling
                  </Button>
                  <Button
                    disabled={selectedRows.length === 0 ? true : false}
                    color="warning"
                    sx={{ ml: 2 }}
                    variant="contained"
                    size="small"
                    onClick={() => {
                      setDeleteConfirm(true);
                    }}
                  >
                    Delete
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Box
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            gap={1.5}
          >
            <Typography
              sx={{ fontWeight: "bold", pt: "5px" }}
              variant="subtitle2"
              gutterBottom
            >
              {productType == 0 ? "Wholegoods" : "Parts"} default price level:
            </Typography>
            {priceOptions
              .filter(
                (x) =>
                  x.type ===
                  PricingType[
                    value === "Wholegoods"
                      ? dmsSetup?.priceType ?? "Price"
                      : dmsSetup?.partsPriceType ?? "Price"
                  ]
              )
              .map((option) => (
                <Typography fontSize="0.9rem">{option.label}</Typography>
              ))}
          </Box>
        </Box>

        <Card>
          <CardContent sx={{ padding: 0, paddingBottom: "0px !important" }}>
            <TabContext value={value.toString()}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList
                  onChange={handleTabChange}
                  aria-label="lab API tabs example"
                  className="custom-tab-list"
                >
                  {productTypes?.some((n) => n === "Wholegoods") && (
                    <Tab label={"Wholegoods"} value={"Wholegoods"} />
                  )}
                  {productTypes?.some((n) => n === "Parts") && (
                    <Tab label={"Parts"} value={"Parts"} />
                  )}
                </TabList>
              </Box>

              {
                <TabPanel value="Wholegoods" style={{ padding: 0 }}>
                  <ServerAppGrid
                    data={syncProductResult.isLoading ? [] : products}
                    columns={GetAppGridColumns(
                      columns,
                      WGgridSetting?.columnVisibilityModel
                    )}
                    isLoading={syncProductResult.isLoading}
                    selectedRows={selectedRows}
                    onSelect={(newSelection: any) => {
                      setSelectedRows(newSelection);
                    }}
                    paging={paging}
                    setPaging={setPaging}
                    totalRecords={productsCount}
                    keepNonExistentRowsSelected={false}
                    gridId={AppGridId.Product_Manager_Wholegoods}
                    height={"70vh"}
                  ></ServerAppGrid>
                </TabPanel>
              }
              <TabPanel value="Parts" style={{ padding: 0 }}>
                <ServerAppGrid
                  data={syncProductResult.isLoading ? [] : products}
                  columns={GetAppGridColumns(
                    partsColumns,
                    PartgridSetting?.columnVisibilityModel
                  )}
                  isLoading={syncProductResult.isLoading}
                  selectedRows={selectedRows}
                  onSelect={(newSelection: any) => {
                    setSelectedRows(newSelection);
                  }}
                  paging={paging}
                  setPaging={setPaging}
                  totalRecords={productsCount}
                  keepNonExistentRowsSelected={false}
                  gridId={AppGridId.Product_Manager_Parts}
                  height={"70vh"}
                ></ServerAppGrid>
              </TabPanel>
            </TabContext>
          </CardContent>
        </Card>
      </Container>
      {openPriceRule && (
        <PriceRule
          handleClose={handleClosePriceRule}
          productType={
            value === "Wholegoods" ? ProductType.Wholegoods : ProductType.Parts
          }
          productIds={selectedRows ?? []}
          isOpen={openPriceRule}
        />
      )}
      <Dialog open={openStockForm} fullWidth>
        <DialogTitle sx={{ textAlign: "center" }}>Stock Decision</DialogTitle>
        <DialogContent>
          <FormLabel id="demo-controlled-radio-buttons-group">
            Do you want to sell these items even if it's out of stock?
          </FormLabel>
          <Stack
            direction="row"
            spacing={1}
            justifyContent="center"
            alignItems="center"
            mt={3}
          >
            <Typography>No</Typography>
            <Switch
              aria-labelledby="demo-controlled-radio-buttons-group"
              checked={checked}
              name="status"
              onChange={handleDecisionChange}
              inputProps={{ "aria-label": "controlled" }}
            />
            <Typography>Yes</Typography>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button size="small" variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={handleStockDecisionSubmit}
            disabled={setStockDecisionMutationResult.isLoading}
            endIcon={
              setStockDecisionMutationResult.isLoading ? (
                <CircularProgress size="1.2rem" color="inherit" />
              ) : null
            }
          >
            Apply
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog fullWidth open={deleteConfirm}>
        <DialogTitle style={{ textAlign: "center" }}>
          Confirm to delete
        </DialogTitle>
        <DialogContent>Are you sure to delete selected items?</DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              setDeleteConfirm(false);
            }}
          >
            No
          </Button>
          <Button
            variant="contained"
            size="small"
            onClick={handleDeleteSubmit}
            disabled={deleteBulkProductsMutationResult.isLoading}
            endIcon={
              deleteBulkProductsMutationResult.isLoading ? (
                <CircularProgress size="1.2rem" />
              ) : null
            }
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openHidePrice}
        onClose={handleClose}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          style={{ textAlign: "center" }}
          id="draggable-dialog-title"
        >
          Confirm to {hideValue ? "Hide" : "Show"} Price
        </DialogTitle>
        <DialogContent>
          The prices and "Add to Cart" buttons of selected products will{" "}
          {hideValue ? "be hide " : "start to shown "}
          on Shopify?
          <br />
          Are you sure to perform this action?{" "}
          {isOperationRunning ? (
            <Alert sx={{ mt: 1 }} severity="warning">
              A bulk operation for price updates is already running. Please wait
              for a while to complete it!
            </Alert>
          ) : (
            ""
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              setOpenHidePrice(false);
            }}
          >
            No
          </Button>
          <Button
            variant="contained"
            size="small"
            disabled={hidePriceMutationMutationResult.isLoading}
            endIcon={
              hidePriceMutationMutationResult.isLoading ? (
                <CircularProgress size="1.2rem" />
              ) : null
            }
            onClick={handleHidePrice}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openPrices}
        onClose={handleClose}
        PaperProps={{ style: { minHeight: "40vh" } }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: "2px",
          }}
        >
          <Typography color="primary" sx={{ fontWeight: "bold" }}>
            Product Level Price Setting
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Table aria-label="prices table">
            <TableBody>
              {priceOptions
                .filter(
                  ({ key }) =>
                    !isValueNullOrZero(selectedRowData?.aggregatePrices?.[key])
                )
                .map(({ label, key, type }) => (
                  <StyledTableRow
                    key={key}
                    sx={{ bgcolor: handleGetRowColor(type) }}
                  >
                    <StyledTableCell width="40%">{label}</StyledTableCell>
                    <StyledTableCell align="right">
                      {selectedRowData?.aggregatePrices?.[key]?.toFixed(2) ?? 0}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {selectedRowData?.priceType === PricingType[type] ? (
                        <Chip label="Applied" color="success" size="small" />
                      ) : (
                        <Button
                          sx={{ lineHeight: 1.4, fontSize: "0.7125rem" }}
                          variant="contained"
                          color="warning"
                          size="small"
                          onClick={() =>
                            handleUpdatePrice(
                              type,
                              selectedRowData?.aggregatePrices?.[key],
                              selectedRowData?.price >
                                selectedRowData?.aggregatePrices?.[key]
                                ? selectedRowData.price
                                : selectedRowData?.aggregatePrices?.[key]
                            )
                          }
                        >
                          {updatePriceMutationResult.isLoading &&
                          priceType === type &&
                          !isResetRequest ? (
                            <CircularProgress size="1.2rem" color="inherit" />
                          ) : (
                            "Apply"
                          )}
                        </Button>
                      )}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              <StyledTableRow sx={{ height: 40 }}>
                <StyledTableCell
                  sx={{ color: "primary", fontWeight: "bold" }}
                  align="center"
                  colSpan={3}
                >
                  <Tooltip title="After resetting, selected default price level will be applied on this product">
                    <Button
                      disabled={updatePriceMutationResult.isLoading}
                      sx={{ height: 25, fontSize: "0.7125rem" }}
                      variant="contained"
                      color="error"
                      size="small"
                      onClick={() => {
                        const priceType =
                          productType === 0
                            ? dmsSetup?.priceType ?? PricingType.Price
                            : dmsSetup?.partsPriceType ?? PricingType.Price;

                        const selectedPrice = handleGetProductPrice(
                          selectedRowData,
                          priceType
                        );

                        handleUpdatePrice(
                          priceType,
                          selectedPrice,
                          selectedRowData?.price > selectedPrice
                            ? selectedRowData.price
                            : selectedPrice
                        );
                      }}
                    >
                      {updatePriceMutationResult.isLoading && isResetRequest ? (
                        <CircularProgress size="1.2rem" color="inherit" />
                      ) : (
                        "Reset Price"
                      )}
                    </Button>
                  </Tooltip>
                </StyledTableCell>
              </StyledTableRow>
            </TableBody>
          </Table>
          {selectedRowData?.activePromotion && (
            <Alert severity="info">
              This item has an active promotion which will end on{" "}
              {formatDate(selectedRowData?.activePromotion?.endDate)}. You can
              apply any price level, once the promotion ends, the selected price
              will be applied automatically.
            </Alert>
          )}
        </DialogContent>
      </Dialog>

      <Dialog
        open={openShopifyDetails}
        fullWidth={true}
        maxWidth="lg"
        disableEnforceFocus={true}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: 0,
            paddingLeft: "16px",
            paddingRight: "16px",
          }}
        >
          <h4>Website Product Details</h4>
          <IconButton
            onClick={() => {
              handleClose();
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ width: "100%" }}>
          <ShopifyProductDetails
            shopifyProductId={selectedRowData?.shopifyProductId}
            aggregateId={selectedRowData?.id} //aggregateId decides at backend if need to update catalog sync bit or not
            setOpenShopifyDetails={setOpenShopifyDetails}
            setShowAlertMessage={setShowAlertMessage}
            setShowSaveAlert={setShowSaveAlert}
            handleUpdateMatchingType={handleUpdateProductMatchingType}
          ></ShopifyProductDetails>
        </DialogContent>
      </Dialog>
      <Dialog open={openRevertCustom} fullWidth onClose={handleClose}>
        <DialogTitle>Confirm to Revert Custom</DialogTitle>
        <DialogContent>
          Are you sure you want to remove your custom changes and use details
          from Catalog?
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            size="small"
            autoFocus
            onClick={() => {
              setOpenRevertCustom(false);
            }}
          >
            Keep Custom
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={handleRevertCustomDetails}
            disabled={revertCustomDetailsMutationResult.isLoading}
            endIcon={
              revertCustomDetailsMutationResult.isLoading ? (
                <CircularProgress size="1.2rem" />
              ) : null
            }
          >
            Use Catalog
          </Button>
        </DialogActions>
      </Dialog>
      <SnackBarPopup
        severity="success"
        message={showAlertMessage}
        onClose={() => setShowSaveAlert(false)}
        open={showSaveAlert}
        autoHideDuration={3000}
      ></SnackBarPopup>
      <Dialog fullWidth open={productDeleteConfirm}>
        <DialogTitle>Confirm to Delete</DialogTitle>
        <DialogContent>
          This action will delete this item from TargetWeb and Shopify.
        </DialogContent>
        <DialogActions>
          <Button
            size="small"
            variant="outlined"
            onClick={() => {
              setProductDeleteConfirm(false);
            }}
          >
            No
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={handleDeleteProduct}
            disabled={deleteBulkProductsMutationResult.isLoading}
            endIcon={
              deleteBulkProductsMutationResult.isLoading ? (
                <CircularProgress size="1.2rem" />
              ) : null
            }
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog fullWidth open={openResetPrice} onClose={handleClose}>
        <DialogTitle style={{ textAlign: "center" }}>
          <Typography color="primary" sx={{ fontWeight: "bold" }}>
            Reset Price Setting
          </Typography>
        </DialogTitle>
        <DialogContent>
          Are you sure you want to reset the price setting of selected items?
          <Alert sx={{ mt: 2 }} severity="warning">
            This action will update the <b>price</b> and <b>price type</b> with
            selected default price level.
          </Alert>
          {errorMessage && (
            <Alert sx={{ mt: 2 }} severity="warning">
              {errorMessage}
            </Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button size="small" variant="outlined" onClick={handleClose}>
            No
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={handleResetPrice}
            disabled={resetPriceSyncMutationResult.isLoading}
            endIcon={
              resetPriceSyncMutationResult.isLoading ? (
                <CircularProgress size="1.2rem" />
              ) : null
            }
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ProductManagement;
